import React from 'react';

export const NextStep = () => {

  const nextButton = (e) => {
    const selectItemParent = e.currentTarget.closest('.mtm-item__wrapper');
    const selectItemName = selectItemParent.id.replace('mtm-', '');

    if (selectItemParent.nextElementSibling) {
      selectItemParent.nextElementSibling.classList.add('active');
      if (selectItemParent.nextElementSibling.id == 'mtm-label') {
        selectItemParent.nextElementSibling.nextElementSibling.classList.add('active');
      }
      const nextScroll = document.getElementById(selectItemParent.nextElementSibling.id);
      const nextScrollRect = nextScroll.getBoundingClientRect();
      const nextScrollTop = nextScrollRect.top;
      const scrollDistance = window.pageYOffset + nextScrollTop;
      const header_h = document.getElementById('SiteHeader').clientHeight;
      const targetTop = scrollDistance - header_h;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });
    }
    
    const dataTimelineName = "mtm-" + selectItemName;
    const dataTimeline = document.querySelectorAll('[data-timeline="'+dataTimelineName+'"]');
    dataTimeline[0].nextElementSibling.classList.add('active');
  }

  return (
    <div className="selects-item__detail_button">
      <button onClick={nextButton}>Next Step</button>
    </div>
  )
};
